import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';

import { messages } from './messages';

const CityColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  const { returnConfiguration } = ret || {};
  const { shipTo } = returnConfiguration || {};
  const { city } = shipTo || {};

  return city;
};

export const City = {
  getMessageDescriptor: () => messages.city,
  id: 'city',

  render: ({ fulfillmentId }) => {
    return <CityColumn fulfillmentId={fulfillmentId} />;
  },
};
